"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var address_1 = tslib_1.__importDefault(require("./address"));
var bank_1 = tslib_1.__importDefault(require("./bank"));
var normalization_1 = require("rest-resource/dist/helpers/normalization");
var CompanyResource = /** @class */ (function (_super) {
    tslib_1.__extends(CompanyResource, _super);
    function CompanyResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CompanyResource.endpoint = '/companies';
    CompanyResource.MODEL_NAME = 'company';
    CompanyResource.related = {
        address: address_1.default,
        bank: bank_1.default,
    };
    // Manually override normalization -- endpoints using some address fields are nested
    // This can be removed once we get rid of NestedSerializer in backend @todo
    CompanyResource.normalization = {
        bank: new normalization_1.StringNormalizer()
    };
    return CompanyResource;
}(base_1.default));
exports.default = CompanyResource;
//# sourceMappingURL=company.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/company.js
// module id = V+R9
// module chunks = 0